module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAE9SURBVDhPYxhcIJKHL+GNotp/EL4rr/JejoVVASQewM0bhiwOVgwFTFAaDJZ/+bQAymTgZ2ISgDIZ9n//ugvKRBEHARQDpFhYZKBMhkd/fj8AYRCbm4mJBywIBDAxGEAxQISJWQzKZDj64/sBKJNBmplFFspkeIzPAHZGRnYok+Hqz58XoUygy1jhLgMafBDKBAMUA3iZmPmgTIYIXr54aw4uB1N2DktpFoQLrvz8eQHKBANGKA0GemzsRvuk5c9CuViB0eP7isjhgOKCG79/XU1+9TwMygUDZMVXfv28gB6IeAEoys7JKt6HpQFQOoFKwQGKF1qERfu3f/26EcTWZWM3SOMXyIclJpDtDk8fGoLYyADFAJAtUCYKAGn2f/7Y8eO/fx+gQnCAEgboCkAac1+/SATZjE3zYAAMDAC8GH6Z+e1XjAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/youdao_fanyi_logo.png
// module id = +wDD
// module chunks = 2